import React, { ReactNode, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';

import deleteIcon from '../../assets/icons/icon_delete.svg';
import refreshIcon from '../../assets/icons/icon_refresh.svg';
import { ColoredIcon } from '../../common/components/Icon';
import { WindowSize, WindowSizeContext } from '../../hooks/windowSizeHook';

import { DownloadMultipleCaseButton } from './DownloadMultipleCaseButton';
import { RequestCdButton } from './RequestCdButton';

const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  column-gap: inherit;
  row-gap: inherit;
`;
interface ImageListTableButtonsProps {
  onClickCDButton: () => void;
  caseIds: string[];
  refreshCase: () => void;
  onClickDeleteImagesButton: () => void;
}
export const ImageListTableButtons = ({
  onClickCDButton,
  caseIds,
  refreshCase,
  onClickDeleteImagesButton,
}: ImageListTableButtonsProps) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.imageList',
  });
  return (
    <Buttons>
      {!!process.env.REACT_APP_CD_DELIVERY && (
        <RequestCdButton onClick={onClickCDButton} />
      )}
      <DownloadMultipleCaseButton caseIds={caseIds} />
      <ImageListTableButton
        icon={refreshIcon}
        text={`${t('myImageList.refreshButton')}`}
        onClick={refreshCase}
      />
      <ImageListTableButton
        icon={deleteIcon}
        text={`${t('myImageList.deleteButton.label')}`}
        onClick={onClickDeleteImagesButton}
      />
    </Buttons>
  );
};

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 85px;
  padding: 5px;
  background-color: #ffffff;
  border: 1px solid #f3f3f3;
  border-radius: 8px;

  font-size: 14px;
  font-weight: 500;
  color: var(--HPACS_Text_Light_Grey, #a3a6ab);
  white-space: nowrap;
  cursor: pointer;
  ${p =>
    p.theme.isMobile &&
    'flex-direction: column; align-items: center; min-width: 68px;'};
`;
interface ImageListTableButtonProps {
  text?: string | ReactNode;
  onClick?: () => void;
  icon?: string;
}
export const ImageListTableButton = ({
  text,
  icon,
  onClick,
}: ImageListTableButtonProps) => {
  const isMobile = useContext(WindowSizeContext) === WindowSize.MOBILE;
  return (
    <Button onClick={onClick}>
      {icon?.length && (
        <ColoredIcon
          width="24px"
          height="24px"
          margin={isMobile ? '0' : '0px 11px 0px 0px'}
          imageUrl={icon}
          imageWidth="18px"
          color="var(--HPACS_Text_Light_Grey, #a3a6ab)"
        />
      )}
      {text}
    </Button>
  );
};
